import React from "react";
import Select2 from "react-select2-wrapper";
import {ListGroup} from 'react-bootstrap';
import { useHistory } from "react-router-dom";
import {Button} from 'react-bootstrap';
import { getPartnerIdFromDomain } from "../../partnerDomain";

export const SearchResult = ({result, setInputValue}) => {
  const history = useHistory();

  const handleClick = () => {
    localStorage.setItem("plz", result.postleitzahl);
    const partnerId = getPartnerIdFromDomain();
    if (partnerId) {
      history.push(`/detail?id=${partnerId}`);
    } else {
      history.push(`/listing?plz=${result.postleitzahl}&ort=${result.bezirk}`);
    }
  }  
  
  return(
      <Button variant="light" className="list-group-item text-left pl-3" onClick={handleClick}>{result.postleitzahl} {result.bezirk}</Button>
    )
}